import { NgModule, ModuleWithProviders } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MdInputModule, MdIconModule, MdButtonModule } from '@angular/material';

import { TdSearchInputComponent } from './search-input/search-input.component';
import { TdSearchBoxComponent } from './search-box/search-box.component';

export { TdSearchBoxComponent } from './search-box/search-box.component';
export { TdSearchInputComponent } from './search-input/search-input.component';
export class QuiverSearchModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    FormsModule,
    CommonModule,
    MdInputModule,
    MdIconModule,
    MdButtonModule,
  ],
  declarations: [
    TdSearchInputComponent,
    TdSearchBoxComponent,
  ],
  exports: [
    TdSearchInputComponent,
    TdSearchBoxComponent,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverSearchModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverSearchModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverSearchModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
